require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/core-js/modules/es6.array.species.js
// module id = 637
// module chunks = 81